import Link from 'next/link';

import * as types from 'shared/components/NewNavbar/types';

import styles from './NavLink.module.scss';

export function NavLink({
  bold,
  className = '',
  orange,
  activeMenu,
  children,
  aTag = false,
  ...linkProps
}: types.NavLink) {
  return aTag ? (
    <a
      className={`${styles.navLink} ${bold ? styles['navLink--bold'] : ''} ${orange ? styles['navLink--orange'] : ''} ${activeMenu ? styles['navLink--active'] : ''} ${className}`}
      href={typeof linkProps.href === 'string' ? linkProps.href : ''}
    >
      {children}
    </a>
  ) : (
    <Link
      className={`${styles.navLink} ${bold ? styles['navLink--bold'] : ''} ${orange ? styles['navLink--orange'] : ''} ${activeMenu ? styles['navLink--active'] : ''} ${className}`}
      {...linkProps}
    >
      {children}
    </Link>
  );
}
